/** Canonical brand facts for Kanata Indonesia. Single source of truth. */

export const brand = {
  name: "Kanata Indonesia",
  shortName: "Kanata",
  tagline: "Standing desk yang benar, dengan harga yang masuk akal.",
  origin: "Dibuat di Indonesia",
  positioning: "Salah satu produsen standing desk ergonomis terbesar di Indonesia",
  community: "Kanata Family",
  /** Primary brand green (from the logo wordmark). */
  colors: {
    green: "#007b4e",
    greenDark: "#005f3c",
    greenLight: "#e6f2ec",
  },
} as const;

export const contact = {
  whatsappNumber: "+62 815 9188 588",
  /** Short link (wa.link) for generic "message us" CTAs. */
  whatsappUrl: "https://wa.link/9yjr7g",
  /** Digits-only international number for building wa.me deep links with prefilled text. */
  whatsappDigits: "628159188588",
  email: "Kanataindo@gmail.com",
  showroom:
    "Jl. Hj Lebar Blok 35 No. 7, RT.6/RW.2, Meruya Utara, Kembangan, Jakarta Barat, DKI Jakarta 11610",
  showroomShort: "Meruya Utara, Jakarta Barat",
} as const;

/**
 * Marketplace storefronts.
 *
 * Kanata now sells directly on this site — these are where customers who
 * prefer a marketplace can buy instead, NOT the buy path. Nothing in the
 * storefront should route a purchase here.
 *
 * The shops moved to the kanataworkspace handle on 4 Nov 2026. Tokopedia is
 * where the short link the shop shares (tk.tokopedia.com) lands.
 */
export const channels = {
  tokopedia: "https://www.tokopedia.com/kanata-workspace",
  shopee: "https://shopee.co.id/kanataworkspace",
  tiktok: "https://www.tiktok.com/@kanataworkspace",
  whatsapp: "https://wa.link/9yjr7g",
} as const;

export const socials = {
  instagram: "https://www.instagram.com/kanataworkspace/",
  tiktok: "https://www.tiktok.com/@kanataworkspace",
  youtube: "https://www.youtube.com/channel/UCfKl218pfHvqfndTxh7wYtw",
  linkedin: "https://www.linkedin.com/company/kanata-indonesia/",
  tokopedia: "https://www.tokopedia.com/kanata-workspace",
  shopee: "https://shopee.co.id/kanataworkspace",
} as const;

/** B2B construction partner. */
export const partner = {
  name: "PT. New Rehobot",
  note: "40+ years of office construction & fit-out",
  url: "https://nrbcorporation.com",
} as const;
